import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';

// Components
import AddedToBookedVendorTag from 'components/manage/website/entities/Events/AddedToBookedVendorTag';
import { Tag } from '@zola/zola-ui/src/components/Tag';

// Utils
import featureFlags from 'util/featureFlags';

import { EntityName, EntityDesciption } from '../EditPageCommon/EditPageSortableList';

const isVenueToBookedVendorsEnabled = featureFlags.get('venueToBookedVendors');

const EventDetails = entity => {
  const event = entity || {};
  const {
    name,
    public: isPublic,
    venue_name: venuName,
    start_at: startAt,
    end_at: endAt,
    virtual_meeting: virtualMeeting,
    hash,
    reference_vendor_uuid: referenceVendorUuid,
    created,
  } = event;
  const trimmedEventName = name && name.length > 30 ? `${name.slice(0, 30)}...` : name;
  const eventStart = moment.utc(startAt).format('ddd, MMM D, YYYY, h:mm a');
  const eventEnd = endAt && moment.utc(event.end_at).format('h:mm a');
  const noBubble = e => {
    e.stopPropagation();
  };

  return (
    <>
      <div className="event-visibility">
        <EntityName name={trimmedEventName} />
        <Tag type={isPublic ? 'primary' : 'red'}>{isPublic ? 'Public' : 'Private'}</Tag>
      </div>
      <EntityDesciption>
        <div className="event-date">
          {eventStart}
          {eventEnd && ` - ${eventEnd}`}
        </div>
        <div className="event-venu-name">
          {venuName}{' '}
          {isVenueToBookedVendorsEnabled ? (
            <AddedToBookedVendorTag
              inline
              eventCreated={created}
              referenceVendorUuid={referenceVendorUuid}
            />
          ) : (
            <></>
          )}
        </div>
        {virtualMeeting && (
          <Link to={`/wedding/manage/website/virtual-event/${hash}`} onClick={noBubble}>
            Manage your virtual event
          </Link>
        )}
        {isVenueToBookedVendorsEnabled ? (
          <AddedToBookedVendorTag
            eventCreated={created}
            referenceVendorUuid={referenceVendorUuid}
          />
        ) : (
          <></>
        )}
      </EntityDesciption>
    </>
  );
};

export default EventDetails;
